var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDocumentPdf = function SvgDocumentPdf(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 35,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#documentPdf_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFBABD",
    fillOpacity: 0.39,
    d: "M27.666 35H7.334a2.905 2.905 0 0 1-2.905-2.905V2.905C4.43 1.3 5.73 0 7.334 0h13.33c.743 0 1.457.284 1.996.795l7.002 6.624c.58.548.909 1.311.909 2.11v22.566c0 1.605-1.3 2.905-2.905 2.905"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E11B22",
    d: "M29.662 7.419 22.66.795A2.9 2.9 0 0 0 20.664 0H17.5v35h10.166c1.604 0 2.905-1.3 2.905-2.905V9.53c0-.799-.329-1.562-.909-2.11"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A90006",
    d: "M22.873 8.714h7.58a2.9 2.9 0 0 0-.79-1.295L22.66.795A2.9 2.9 0 0 0 21.421.1v7.16c0 .802.65 1.453 1.452 1.453"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M26.004 15.723H8.996c-.589 0-1.066-.46-1.066-1.026s.477-1.025 1.066-1.025h17.008c.589 0 1.066.459 1.066 1.025 0 .567-.477 1.026-1.066 1.026M26.004 21.191H8.996c-.589 0-1.066-.459-1.066-1.025s.477-1.025 1.066-1.025h17.008c.589 0 1.066.459 1.066 1.025s-.477 1.025-1.066 1.025M14.85 26.66H8.996c-.589 0-1.066-.459-1.066-1.025 0-.567.477-1.026 1.066-1.026h5.854c.589 0 1.066.46 1.066 1.026s-.477 1.025-1.066 1.025"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFE4E5",
    d: "M27.07 14.697c0-.566-.477-1.025-1.066-1.025H17.5v2.05h8.504c.589 0 1.066-.458 1.066-1.025M26.004 19.14H17.5v2.051h8.504c.589 0 1.066-.459 1.066-1.025s-.477-1.025-1.066-1.025"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "documentPdf_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h35v35H0z"
  })))));
};
export default SvgDocumentPdf;